var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "청약안내",
            "tabActive": "임대조건",
            "bg": "/images/sub/subscription/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("청약안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("임대조건")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "page-section__content"
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--xs"
  }, [_c('tit-tertiary', [_vm._v("특별공급")])], 1), _c('div', {
    staticClass: "pb-18px pb-md-24px"
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('txt-quarternary', [_vm._v("총 63세대")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-chip-group', [_c('chip-tertiary', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("청년형 | 54세대")]), _c('chip-tertiary', {
    attrs: {
      "color": "tertiary"
    }
  }, [_vm._v("신혼부부형 | 9세대")])], 1)], 1)], 1)], 1), _c('txt-primary', {
    staticClass: "text-right grey--text text--lighten-1"
  }, [_vm._v("(단위: 만원)")]), _c('div', {
    staticClass: "v-data-table v-data-table--border v-data-table--line v-data-table--density-comfortable my-10px"
  }, [_c('div', {
    staticClass: "v-data-table__wrapper"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("공급유형")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("주거전용(타입)")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("공급호수")]), _c('th-primary', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("보증금 30%")]), _c('th-primary', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("보증금 35%")]), _c('th-primary', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("보증금 40%")])], 1), _c('tr', [_c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("보증금")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("임대료")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("보증금")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("임대료")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("보증금")]), _c('th-secondary', [_vm._v("임대료")])], 1)]), _c('tbody', [_c('tr', [_c('th-secondary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("청년형"), _c('br'), _vm._v("(1인)")]), _c('td-primary', [_vm._v("20.17㎡ (25A)")]), _c('td-primary', [_vm._v("14")]), _c('td-primary', [_vm._v("5,700")]), _c('td-primary', [_vm._v("60")]), _c('td-primary', [_vm._v("6,700")]), _c('td-primary', [_vm._v("55")]), _c('td-primary', [_vm._v("7,600")]), _c('td-primary', [_vm._v("51")])], 1), _c('tr', [_c('td-primary', [_vm._v("20.40㎡ (25B)")]), _c('td-primary', [_vm._v("40")]), _c('td-primary', [_vm._v("5,700")]), _c('td-primary', [_vm._v("60")]), _c('td-primary', [_vm._v("6,700")]), _c('td-primary', [_vm._v("55")]), _c('td-primary', [_vm._v("7,600")]), _c('td-primary', [_vm._v("51")])], 1), _c('tr', {
    staticClass: "table-divider"
  }, [_c('td-primary', {
    staticClass: "grey lighten-5 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("소계")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }, [_vm._v("54")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  })], 1), _c('tr', [_c('th-secondary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("신혼부부형"), _c('br'), _vm._v("(예비신혼포함)")]), _c('td-primary', [_vm._v("41.25㎡ (52A)")]), _c('td-primary', [_vm._v("3")]), _c('td-primary', [_vm._v("10,600")]), _c('td-primary', [_vm._v("111")]), _c('td-primary', [_vm._v("12,400")]), _c('td-primary', [_vm._v("103")]), _c('td-primary', [_vm._v("14,100")]), _c('td-primary', [_vm._v("95")])], 1), _c('tr', [_c('td-primary', [_vm._v("42.17㎡ (52B)")]), _c('td-primary', [_vm._v("6")]), _c('td-primary', [_vm._v("10,600")]), _c('td-primary', [_vm._v("111")]), _c('td-primary', [_vm._v("12,400")]), _c('td-primary', [_vm._v("103")]), _c('td-primary', [_vm._v("14,100")]), _c('td-primary', [_vm._v("95")])], 1), _c('tr', {
    staticClass: "table-divider"
  }, [_c('td-primary', {
    staticClass: "grey lighten-5 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("소계")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }, [_vm._v("9")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  })], 1), _c('tr', [_c('td-primary', {
    staticClass: "grey lighten-3 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("합계")]), _c('td-primary', {
    staticClass: "grey lighten-3 grey--text text--darken-4 font-weight-bold"
  }, [_vm._v("63")]), _c('td-primary', {
    staticClass: "grey lighten-3 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("전체 민간임대 세대수의 20%")])], 1)])])])])], 1), _c('div', {
    staticClass: "page-section__content"
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--xs"
  }, [_c('tit-tertiary', [_vm._v("일반공급")])], 1), _c('div', {
    staticClass: "pb-18px pb-md-24px"
  }, [_c('v-row', {
    staticClass: "row--sm",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('txt-quarternary', [_vm._v("총 250세대")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-chip-group', [_c('chip-tertiary', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("청년형 | 215세대")]), _c('chip-tertiary', {
    attrs: {
      "color": "tertiary"
    }
  }, [_vm._v("신혼부부형 | 35세대")])], 1)], 1)], 1)], 1), _c('txt-primary', {
    staticClass: "text-right grey--text text--lighten-1"
  }, [_vm._v("(단위: 만원)")]), _c('div', {
    staticClass: "v-data-table v-data-table--border v-data-table--line v-data-table--density-comfortable my-10px"
  }, [_c('div', {
    staticClass: "v-data-table__wrapper"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("공급유형")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("주거전용(타입)")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("공급호수")]), _c('th-primary', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("보증금 30%")]), _c('th-primary', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("보증금 35%")]), _c('th-primary', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("보증금 40%")])], 1), _c('tr', [_c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("보증금")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("임대료")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("보증금")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("임대료")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("보증금")]), _c('th-secondary', [_vm._v("임대료")])], 1)]), _c('tbody', [_c('tr', [_c('th-secondary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("청년형"), _c('br'), _vm._v("(1인)")]), _c('td-primary', [_vm._v("20.17㎡ (25A)")]), _c('td-primary', [_vm._v("57")]), _c('td-primary', [_vm._v("7,000")]), _c('td-primary', [_vm._v("73")]), _c('td-primary', [_vm._v("8,100")]), _c('td-primary', [_vm._v("68")]), _c('td-primary', [_vm._v("9,300")]), _c('td-primary', [_vm._v("62")])], 1), _c('tr', [_c('td-primary', [_vm._v("20.40㎡ (25B)")]), _c('td-primary', [_vm._v("158")]), _c('td-primary', [_vm._v("7,000")]), _c('td-primary', [_vm._v("73")]), _c('td-primary', [_vm._v("8,100")]), _c('td-primary', [_vm._v("68")]), _c('td-primary', [_vm._v("9,300")]), _c('td-primary', [_vm._v("62")])], 1), _c('tr', {
    staticClass: "table-divider"
  }, [_c('td-primary', {
    staticClass: "grey lighten-5 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("소계")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }, [_vm._v("215")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  })], 1), _c('tr', [_c('th-secondary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("청년 또는 "), _c('br', {
    staticClass: "d-none d-sm-block"
  }), _vm._v("신혼부부형 "), _c('br', {
    staticClass: "d-none d-sm-block"
  }), _vm._v("(예비신혼포함)")]), _c('td-primary', [_vm._v("41.25㎡ (52A)")]), _c('td-primary', [_vm._v("13")]), _c('td-primary', [_vm._v("12,900")]), _c('td-primary', [_vm._v("136")]), _c('td-primary', [_vm._v("15,100")]), _c('td-primary', [_vm._v("126")]), _c('td-primary', [_vm._v("17,300")]), _c('td-primary', [_vm._v("116")])], 1), _c('tr', [_c('td-primary', [_vm._v("42.17㎡ (52B)")]), _c('td-primary', [_vm._v("22")]), _c('td-primary', [_vm._v("12,900")]), _c('td-primary', [_vm._v("136")]), _c('td-primary', [_vm._v("15,100")]), _c('td-primary', [_vm._v("126")]), _c('td-primary', [_vm._v("17,300")]), _c('td-primary', [_vm._v("116")])], 1), _c('tr', {
    staticClass: "table-divider"
  }, [_c('td-primary', {
    staticClass: "grey lighten-5 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("소계")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }, [_vm._v("35")]), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  }), _c('td-primary', {
    staticClass: "grey lighten-5"
  })], 1), _c('tr', [_c('td-primary', {
    staticClass: "grey lighten-3 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("합계")]), _c('td-primary', {
    staticClass: "grey lighten-3 grey--text text--darken-4 font-weight-bold"
  }, [_vm._v("250")]), _c('td-primary', {
    staticClass: "grey lighten-3 grey--text text--darken-4 font-weight-bold",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("전체 민간임대 세대수의 80%")])], 1)])])])])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }